// extracted by mini-css-extract-plugin
export var buttons = "_br-0";
export var buttonsActive = "_br-h";
export var cancelConfirm = "_br-1";
export var closeButton = "_br-2";
export var column = "_br-3";
export var container = "_br-4";
export var detailHeader = "_br-6";
export var detailTitle = "_br-7";
export var detailsContent = "_br-5";
export var header = "_br-8";
export var headerWithClose = "_br-9";
export var icon = "_br-a";
export var infoIcon = "_br-c";
export var informationContainer = "_br-b";
export var sideDrawer = "_br-d";
export var sideDrawerOpen = "_br-e";
export var stickyFooter = "_br-f";
export var typeOption = "_br-g";